import { render, staticRenderFns } from "./CopyrightDetailsMessages.vue?vue&type=template&id=105609f6&scoped=true&"
import script from "./CopyrightDetailsMessages.vue?vue&type=script&lang=js&"
export * from "./CopyrightDetailsMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105609f6",
  null
  
)

export default component.exports